import { ChangeEvent, FunctionComponent, useCallback, useState } from 'react';
import { Trans } from 'react-i18next';

import ExinMuiRadioGroup from '../styled/ExinMuiRadioGroup';

export enum BookNowOption {
  YES = 'BOOK_NOW_YES',
  NO = 'BOOK_NOW_NO',
}

const OPTIONS = [
  {
    label: <Trans i18nKey="bookNowYesLabel">Yes</Trans>,
    value: BookNowOption.YES,
  },
  {
    label: <Trans i18nKey="bookNowNoLabel">No</Trans>,
    value: BookNowOption.NO,
  },
];

const StepBookNowChoice: FunctionComponent<{
  onChange(value: BookNowOption): void;
}> = ({ onChange }) => {
  const [selected, setSelected] = useState<null | BookNowOption>(null);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value as BookNowOption;
      setSelected(value);
      onChange(value);
    },
    [onChange]
  );

  return <ExinMuiRadioGroup value={selected} onChange={handleChange} options={OPTIONS} />;
};

export default StepBookNowChoice;
